import { Injectable } from '@angular/core';
import { Store } from '@ngrx/store';
import { ToastActions } from '../../store/toast/toast.actions';

export type ToastSeverity = 'success' | 'error' | 'warn' | 'info';

@Injectable({ providedIn: 'root' })
export class ToastService {
  constructor(private store: Store) {}

  show(severity: ToastSeverity, summary: string, detail?: string): void {
    this.store.dispatch(ToastActions.showToast({ severity, summary, detail: detail ?? '' }));
  }

  success(summary: string, detail?: string): void {
    this.show('success', summary, detail);
  }

  error(summary: string, detail?: string): void {
    this.show('error', summary, detail);
  }

  warn(summary: string, detail?: string): void {
    this.show('warn', summary, detail);
  }

  info(summary: string, detail?: string): void {
    this.show('info', summary, detail);
  }
}
